import React from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import RespondPanel from '../components/interview/RespondPanel'

// Phase 2b member Respond page. The actual interface lives in
// components/interview/RespondPanel so Home can embed the same form inline
// for unanswered prompts — keep behavior changes THERE, not here.
//
// An optional `?activation=<id>` deep-links a specific prompt (e.g. from
// "Open in Respond" on /me/responses) so the panel opens that step instead
// of jumping to the first unanswered prompt.
export default function Respond() {
  const { slug } = useParams<{ slug: string }>()
  const [searchParams] = useSearchParams()
  const raw = searchParams.get('activation')
  const parsed = raw ? Number(raw) : NaN
  const initialActivationId = Number.isFinite(parsed) ? parsed : undefined
  return <RespondPanel slug={slug} initialActivationId={initialActivationId} />
}
